import React from 'react';
import { StyledButton } from './styles';
import Loading from '../Loading';

export type ButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  name?: string;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  id?: string;
  children?: React.ReactNode | React.ReactNode[];
  outlined?: boolean;
  fullWidth?: boolean;
  loading?: boolean;
};

const Button = (props: ButtonProps) => {
  const {
    onClick = () => {},
    disabled,
    name,
    type = 'button',
    className,
    id,
    children,
    outlined = false,
    fullWidth = false,
    loading = false,
  } = props;

  return (
    <>
      <StyledButton
        outlined={outlined}
        onClick={onClick}
        disabled={disabled || loading}
        name={name}
        type={type}
        className={className}
        id={id}
        fullWidth={fullWidth}
      >
        {loading ? <Loading size={19} color={outlined ? '#262BA6' : '#fff'} /> : children}
      </StyledButton>
    </>
  );
};

export default Button;
